<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Nueva Contraseña</label>
              <div class="form-group">
                <div class="password-wrapper position-relative">
                  <input
                    type="password" 
                    class="form-control h-45 text-dark"
                    autocomplete="false"
                    placeholder="Ingrese su nueva contraseña"
                    v-model="userPasswordReset.newPassword"
                    @input="clearError('newPassword');checkStrength()"
                  />
                  <i
                    style="color: #a9a9c8; font-size: 16px; right: 15px"
                    class="ri-eye-off-line password-toggle-icon translate-middle-y top-50 position-absolute"
                    aria-hidden="true"
                  ></i>
                  <div class="strength-bar">
                    <div class="strength" :class="strengthClass" :style="{ width: strengthPercent + '%' }"></div>
                  </div>
                  <div class="input-error">{{ errors.newPassword }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Confirmar contraseña</label>
              <div class="form-group">
                <div class="password-wrapper position-relative">
                  <input
                    type="password" 
                    class="form-control h-45 text-dark"
                    autocomplete="false"
                    placeholder="Confirme su nueva contraseña"
                    v-model="userPasswordReset.confirmPassword"
                    @input="clearError('confirmPassword')"
                  />
                  <i
                    style="color: #a9a9c8; font-size: 16px; right: 15px"
                    class="ri-eye-off-line password-toggle-icon translate-middle-y top-50 position-absolute"
                    aria-hidden="true"
                  ></i>
                  <div v-if="errors.confirmPassword"  class="input-error">{{ errors.confirmPassword }}</div> 
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group d-flex gap-3 align-items-center">
              <button
                type="submit"  :disabled="isLoading"
                class="btn btn-primary py-2 px-4 fw-medium fs-16"
              >
                <div class="d-flex align-items-center justify-content-center py-1" >
                  <i v-if="!isLoading" class="material-symbols-outlined text-white fs-20 me-2">
                    autorenew
                  </i>
                  <span v-if="!isLoading">Cambiar contraseña</span> 
                  <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" v-if="isLoading"></span>
                  <span role="status" v-if="isLoading">Procesando...</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted} from "vue"; 
import { userChangePasswordSchema } from "@/schemas/userChangePasswordSchema";
import { useToast } from "vue-toastification";
import { useRouter } from 'vue-router' 
import api from '@/services/api';

export default defineComponent({
  name: "ChangePassword",
  setup() {
    const toast = useToast(); 
    const router = useRouter()
    const isLoading = ref(false);

    const userPasswordReset = ref<{
      newPassword: any;
      confirmPassword: any;
      username: any
    }>({
      newPassword: null,
      confirmPassword: null,
      username: null
    });

    const errors = ref<Record<string, string>>({});
    const strengthPercent = ref(0);
    const strengthClass = ref('');

    onMounted(async () => { 
      const storedUser = localStorage.getItem("user");
      if (storedUser) {  
        userPasswordReset.value.username = JSON.parse(storedUser).email;
      }
      
    });

    const validateForm = async () => {
    
      try {
        errors.value = {};
        await userChangePasswordSchema.validate(userPasswordReset.value, { abortEarly: false   });
        isLoading.value = true;
        
        await changePassword();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " +err)
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = '';
    };
    
    function checkStrength() {
      
      const val = userPasswordReset.value.newPassword  ;
      let strength = 0;

      if(val !=  null){
        if (val.length >= 8) strength += 1;
        if (/[A-Z]/.test(val)) strength += 1;
        if (/[a-z]/.test(val)) strength += 1;
        if (/[0-9]/.test(val)) strength += 1;
        if (/[\W_]/.test(val)) strength += 1;
      }

      strengthPercent.value = (strength / 5) * 100;
console.log("checkStrength:" + strengthPercent.value)
      if (strength <= 2) strengthClass.value = 'strength-bar weak';
      else if (strength === 3 || strength === 4) strengthClass.value = 'strength-bar medium';
      else strengthClass.value = 'strength-bar strong';
    }

    const changePassword = async() => {
        try {
          
          await api.post(`/user/change-password`, userPasswordReset.value);
          toast.success(`La contraseña fue actualizada con éxito.`, {
              timeout: 2000
            });
          
        }catch(ex: any){
          toast.error(ex.response?.data, {
            timeout: 2000
          });
          console.error(ex);
        }
    };

    return { 
      validateForm,
      clearError,
      checkStrength,
      userPasswordReset,
      errors,
      isLoading,
      strengthPercent,
      strengthClass
    };
 
  }
});
</script>
